import React, { Component } from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { orderBy } from "@progress/kendo-data-query";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import DummyLabelHelper from "./DummyLabel"
import Loader from "../Shared/Loader/loader";
import InnerLoader from "../Shared/Loader/InnerLoader";
import AttributeTypes from "./AttributeTypes";
import NoRecord from "../Display/NoRecord";
import Scrollable from "../Shared/Edit/Scrollable";
import { Button } from "@progress/kendo-react-buttons";
import { OverlayLoader } from "../Shared/Loader/OverlayLoader";
import { withTranslation } from "react-i18next";
import { getAttributeTemplate, getAttributeTemplates } from "../../API/AttributeTemplate/AttributeTemplate";
import { createAttribute } from "../../API/Attribute/Attribute";
class SelectAttributeTemplate extends Component {

    DataTypes = AttributeTypes.Types;
    Icons = AttributeTypes.Icons;

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            searchValue: "",
            AttributeTemplate: [],
            allAttributeTemplate: [],
            selectedItem: {},
            adding: false,
            creatingAttribute: false
        };
    }

    componentDidMount = async () => {
        this.getAttributeTemplate();
    };

    render() {
        if (this.state.loading) {
            return <Loader />;
        }

        const { t } = this.props;

        return (
            <Dialog
                title={t("title")}
                onClose={this.closeAttributeDialog}
                width="50%"
                autoFocus
                height="70%"
                className="dialog"
            >
                {this.state.creatingAttribute && <OverlayLoader />}
                <div className="d-flex mb-2 mt-2 align-items-center padding-LR input-group">
                    {/* TODO: Support unicode inside placeholder */}
                    <input
                        className="form-control"
                        onChange={this.sortAttributeTemplate}
                        value={this.state.searchValue}
                        type="text"
                        placeholder={t("search_input_placeholder")}

                    />
                    {/* <a target="_blank" href={process.env.REACT_APP_DESIGNER_URL + "/" + this.props.organizatin.orgName + "/_Organisation/AttributeTemplate"} className="ms-3 text-link pt-2 text-nowrap" >
                        Manage Property Template
                    </a> */}
                </div>

                {this.state.allAttributeTemplate.length === 0 && (
                    <NoRecord message={t("no_record_message")} />
                )}
                {this.state.allAttributeTemplate.length !== 0 && (
                    <Scrollable>
                        <div className="grid-spacer">
                            <Grid
                                className="no-alt"
                                data={this.state.AttributeTemplate.map(
                                    (item, index) => ({
                                        ...item,
                                        selected: item._id === this.state.selectedItem._id,
                                        index,
                                    })
                                )}
                                onRowClick={this.SelectAttributeTemplate}
                                selectedField="selected"
                            >
                                <Column field="indexId" title="#" width={40} />
                                <Column
                                    field="attributeName"
                                    title={t("grid.name_column_header")}
                                    cell={(props) => (
                                        <td>
                                            <span>
                                                {props.dataItem.attributeName}
                                            </span>
                                        </td>
                                    )}
                                />
                                <Column
                                    field="attributeType"
                                    title={t("grid.type_column_header")}
                                    cell={(props) => (
                                        <td>
                                            <i style={{ width: 15 }} className={`${this.Icons[props.dataItem.attributeType]} pe-1 text-center`}></i>
                                            {
                                                props.dataItem.typeText
                                            }
                                        </td>
                                    )}
                                />
                                <Column
                                    field="description"
                                    title={t("grid.description_column_header")}
                                />
                                <Column
                                    cell={(props) => (
                                        <td className="text-end pointer">
                                            {
                                                (this.state.creatingAttribute && this.state.selectedItem._id === props.dataItem._id) ? (
                                                    <div className="d-inline-block float-end text-end">
                                                        <InnerLoader borderColor={"#0c850c"} />
                                                        <span className="me-4 text-success"></span>
                                                    </div>
                                                ) : (
                                                    this.state.creatingAttribute ?
                                                        <button
                                                            disabled={true}
                                                            className="btn p-0 border-0 text-muted fw-bold"
                                                        >
                                                            <i className="mx-1 fa-solid fa-plus"></i>{t("buttons.add")}
                                                        </button>
                                                        :
                                                        <button
                                                            onClick={() => this.CreateAttribute(props.dataItem)}
                                                            disabled={this.shouldAddBeDisabledForAttribute(props.dataItem)}
                                                            className="btn p-0 border-0 t-primary fw-bold"
                                                        >
                                                            <i className="mx-1 fa-solid fa-plus"></i>{t("buttons.add")}
                                                        </button>
                                                )
                                            }
                                        </td>
                                    )}
                                />
                            </Grid>
                        </div>
                    </Scrollable>
                )}


                <DialogActionsBar layout="end">
                    <div className="m-3">
                        <Button
                            onClick={this.closeAttributeDialog}
                            className="btn btn-secondary"
                        >
                            {t("buttons.cancel")}
                        </Button>
                    </div>
                </DialogActionsBar>
            </Dialog>
        );
    }

    getAttributeTemplate = async () => {
        let results = await getAttributeTemplates(this.props.organization._id)
        for (let i = 0; i < results.length; i++) {
            results[i] = this.setProperties(results[i]);
            results[i].indexId = i + 1;
        }
        if (results.length > 0) {
            this.SelectAttributeTemplate(results[0]);
        }
        this.setState({
            AttributeTemplate: results,
            allAttributeTemplate: results,
            loading: false,
        });
    };

    setProperties = (dataItem) => {
        let properties = {};
        properties.attributeName = dataItem.LookupName;
        properties.attributeType = dataItem.lookupType;
        properties.attributeLabel = dataItem.LookupName;
        properties.tooltip = dataItem.LookupName;
        properties.typeText = this.DataTypes.find(
            (type) => type.value === properties.attributeType
        ).text;
        properties.readonly = false;
        properties.group = "";
        properties.defaultValue = dataItem.lookupType === "Boolean" ? false : "";
        delete dataItem["lookupType"];
        delete dataItem["LookupName"];
        delete dataItem["createdDate"];
        delete dataItem["order"];
        delete dataItem["label"];
        delete dataItem["updatedDate"];
        return { ...dataItem, ...properties };
    };

    shouldAddBeDisabledForAttribute = (attribute) => {
        const isStateAttribute = attribute.attributeType === "State Field";
        const hasStateAttribute = this.props.allAttributes.findIndex(attribute => (
            attribute.attributeType === "State Field"
        )) > -1;
        return isStateAttribute && hasStateAttribute;
    }

    SelectAttributeTemplate = (dataItem) => {
        var data = {};

        if (dataItem["dataItem"]) {
            data = dataItem.dataItem;
        } else {
            data = dataItem;
        }
        this.setState({
            selectedItem: data,
        });
    };

    gotoURl = (dataItem) => {
        this.SelectAttributeTemplate(dataItem);

        let url =
            process.env.REACT_APP_DESIGNER_URL +
            "/" +
            this.props.organization.orgName +
            "/_Organisation/AttributeTemplate/" +
            dataItem.sysName;

        window.open(url, "_blank");
    };

    closeAttributeDialog = () => {
        this.props.closeDialog(false);
    };

    getProducts = (sort) => {
        return orderBy(this.state.AttributeTemplate, sort);
    };

    sortAttributeTemplate = (e) => {
        let AttributeTemplate = this.state.allAttributeTemplate;

        if (e.target.value !== "") {
            AttributeTemplate = AttributeTemplate.filter((attr) => attr.attributeName.toLowerCase().includes(e.target.value.trim().toLowerCase()));
        }

        this.setState({
            AttributeTemplate: AttributeTemplate,
            searchValue: e.target.value,
        });
    };

    CreateAttribute = async (data) => {
        this.setState({
            adding: true,
            selectedItem: data,
            creatingAttribute: true
        })

        let dataItem = { ...data };

        let latestAttributeTemplate = await getAttributeTemplate(dataItem._id);
        debugger;
        dataItem = this.setProperties(latestAttributeTemplate);

        let order = 10000000000

        if (this.props.allAttributes.length > 0) {
            order = parseInt(this.props.allAttributes[this.props.allAttributes.length - 1].order) + 10000000000;
        }
        let counter = 0;
        const initialName = dataItem.attributeName;
        let finalName = initialName;
        for (
            let attributeIndex = 0;
            attributeIndex < this.props.allAttributes.length;
            attributeIndex++
        ) {
            if (
                this.props.allAttributes[attributeIndex].attributeName ===
                finalName
            ) {
                ++counter;
                finalName = initialName + "(" + counter + ")";
            }
        }

        dataItem.attributeName = finalName;
        dataItem.attributeLabel = finalName;
        dataItem.required = this.props.data.length === 0;
        dataItem.readOnly = false;
        dataItem.tooltip = finalName;
        dataItem.order = order || 10000000000;
        dataItem.sysName = "attribute";
        delete dataItem["_id"];
        delete dataItem["typeText"];
        delete dataItem["indexId"];
        delete dataItem["cellFormatting"];

        if (
            dataItem.attributeType === "String"
        ) {
            dataItem.dummyLabel = DummyLabelHelper.getDummyLabel(dataItem.attributeLabel, dataItem.attributeType)
        } else if (
            dataItem.attributeType === "URL" ||
            dataItem.attributeType === "Email" ||
            dataItem.attributeType === "Multiline Text" ||
            dataItem.attributeType === "Html"
        ) {
            dataItem.dummyLabel = DummyLabelHelper.TypeMap.find(type => type.type === dataItem.attributeType).value
        } else if (dataItem.attributeType === "State Field") {
            dataItem.required = true;
            dataItem.setStatesRules = false;
        } else if (dataItem.attributeType === "Tree Dropdown") {
            dataItem.treeDropdown = JSON.stringify(dataItem.treeDropdown);
        }

        const attributeWithCellFormatting = ["DateTime", "Tags", "Picklist String", "State Field", "Number"];
        if (attributeWithCellFormatting.includes(dataItem.attributeType)) {
            dataItem.cellFormatting = JSON.stringify({ ifStatement: [], elseStatement: [] });
        }

        const attribute = await createAttribute(this.props.entityId, {
            subscriptionId: this.props.organization.subscriptionId,
            projectId: this.props.project._id,
            properties: dataItem,
        });

        if (attribute.status && attribute.status === "Failure") {
            this.props.closeDialog(true)
        } else {
            attribute.typeText = this.DataTypes.find((type) => type.value === dataItem.attributeType).text;
            attribute.required = attribute.required === true;
            attribute.readOnly = attribute.readOnly === true;
            attribute.multiSelect = attribute.multiSelect === true;
            attribute.indexId = this.props.data.length + 1;
            this.setState({
                adding: false,
                creatingAttribute: false
            });
            this.props.onSelect(attribute, false);
        }
    };
}

export default withTranslation(["attribute/select_attribute_template_dialog"])(
    SelectAttributeTemplate
);
